import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  AccordionDetails: {
    paddingLeft: theme.spacing(6),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3),
    display: 'block',
  },
  section: {
    marginBottom: theme.spacing(4),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  schemaInput: {
    '& textarea': {
      fontFamily: 'monospace',
      minHeight: 100,
    },
  },
  simpleArrayInput: {
    '& li:not(:first-child):not(:last-child)': {
      paddingTop: 20,
    },
    marginBottom: theme.spacing(2),
  },
  inputWidth: {
    width: 320,
  },
  selectWrapper: {
    position: 'relative',
    '&:hover $clearButton': {
      display: 'block',
    },
  },
  clearButton: {
    position: 'absolute',
    top: 14,
    right: 31,
    padding: 5,
    // Shown on hover above
    display: 'none',
  },
  clearButtonIcon: {
    width: 20,
    height: 20,
  },
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    height: '60vh',
  },
  tabRoot: {
    maxWidth: '100%',
  },
  disabledTab: {
    fontSize: 17,
    fontWeight: 600,
    color: theme.palette.text.primary,
    opacity: '1 !important',
  },
  wrapper: {
    display: 'inline',
    textAlign: 'left',
  },
  formWrapper: {
    boxSizing: 'border-box',
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(3),
    width: '100%',
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
}));
